<!-- #63 -->
<template>
  <v-col class="mx-3">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Dock OUT
      </div>
      <v-spacer> </v-spacer>
    </div>

    <v-divider class="mt-1 mb-4"></v-divider>
    <v-card>
      <v-card-text>
        <v-form ref="form" @submit.prevent="save" type="submit">
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                v-model="tokenNumber"
                label="Token Number"
                outlined
                :rules="[
                  (v) => (v && !!v.trim()) || 'Token Number is required.',
                ]"
                class="required"
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-btn color="primary" :loading="loader" @click="save" class="mt-8"
              >Search</v-btn
            >
          </v-row>
        </v-form>
      </v-card-text>
      <v-card v-if="gettokenDetails.token_number" flat>
        <v-card-title class="card-title pb-2 pl-3">Token Details </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-0">
          <v-row class="pl-0">
            <v-col cols="12">
              <v-col cols="12" class="pl-0">
                <div class="col-md-6 d-flex p-0 m-0">
                  <div class="col-md-4 p-0 text-medium-emphasis">
                    Token Number:
                  </div>
                  <div class="text-left col-md-7 p-0">
                    <b> {{ gettokenDetails.token_number }}</b>
                  </div>
                </div>
                <div class="col-md-6 d-flex p-0 m-0">
                  <div class="col-md-4 p-0">Warehouse:</div>
                  <div class="text-left col-md-7 p-0">
                    <b> {{ gettokenDetails.wms_warehouse_code }}</b>
                  </div>
                </div>
                <div
                  class="col-md-6 d-flex p-0 m-0"
                  v-if="gettokenDetails.dock_number"
                >
                  <div class="col-md-4 p-0 text-medium-emphasis">
                    Dock Number Allocated:
                  </div>
                  <div class="text-left col-md-7 p-0">
                    <b> {{ gettokenDetails.dock_number }}</b>
                  </div>
                </div>
                <div class="col-md-6 d-flex p-0 m-0">
                  <div class="col-md-4 p-0">Delivery Date:</div>
                  <div class="text-left col-md-7 p-0">
                    <b> {{ gettokenDetails.delivery_date }}</b>
                  </div>
                </div>
                <div class="col-md-6 d-flex p-0 m-0">
                  <div class="col-md-4 p-0">Purpose:</div>
                  <div class="text-left col-md-7 p-0">
                    <b> {{ gettokenDetails.purpose }}</b>
                  </div>
                </div>
                <div class="col-md-6 d-flex p-0 m-0">
                  <div class="col-md-4 p-0">Security Gaurd Name:</div>
                  <div class="text-left col-md-7 p-0">
                    <b> {{ gettokenDetails.security_guard_name }}</b>
                  </div>
                </div>
                <div class="col-md-6 d-flex p-0 m-0">
                  <div class="col-md-4 p-0">Security Gaurd Phone:</div>
                  <div class="text-left col-md-7 p-0">
                    <b> {{ gettokenDetails.security_guard_phone }}</b>
                  </div>
                </div>
                <div class="col-md-6 d-flex p-0 m-0">
                  <div class="col-md-4 p-0">Supplier Name:</div>
                  <div class="text-left col-md-7 p-0">
                    <b> {{ gettokenDetails.supplier_name }}</b>
                  </div>
                </div>
                <div class="col-md-6 d-flex p-0 m-0">
                  <div class="col-md-4 p-0">Is invoice number available ?:</div>
                  <div class="text-left col-md-7 p-0">
                    <b>
                      {{
                        gettokenDetails.invoice_number_available == 1
                          ? "Yes"
                          : "No"
                      }}</b
                    >
                  </div>
                </div>
                <div class="col-md-6 d-flex p-0 m-0">
                  <div class="col-md-4 p-0">Invoice Number:</div>
                  <div class="text-left col-md-7 p-0">
                    <b> {{ gettokenDetails.invoice_number }}</b>
                  </div>
                </div>
                <div class="col-md-6 d-flex p-0 m-0">
                  <div class="col-md-4 p-0">Invoice Quantity:</div>
                  <div class="text-left col-md-7 p-0">
                    <b> {{ gettokenDetails.invoice_quantity }}</b>
                  </div>
                </div>

                <div class="col-md-6 d-flex p-0 m-0">
                  <div class="col-md-4 p-0">Reason for no invoice:</div>
                  <div class="text-left col-md-7 p-0">
                    <b> {{ gettokenDetails.reason_no_invoice_number }}</b>
                  </div>
                </div>
                <div class="col-md-6 d-flex p-0 m-0">
                  <div class="col-md-4 p-0">Type of vehicle:</div>
                  <div class="text-left col-md-7 p-0">
                    <b> {{ gettokenDetails.vehicle_type }}</b>
                  </div>
                </div>
                <div class="col-md-6 d-flex p-0 m-0">
                  <div class="col-md-4 p-0">Vehicle Number:</div>
                  <div class="text-left col-md-7 p-0">
                    <b> {{ gettokenDetails.vehicle_number }}</b>
                  </div>
                </div>
                <div class="col-md-6 d-flex p-0 m-0">
                  <div class="col-md-4 p-0">Vehicle Temprature:</div>
                  <div class="text-left col-md-7 p-0">
                    <b> {{ gettokenDetails.vehicle_temperature }}</b>
                  </div>
                </div>
                <div class="col-md-6 d-flex p-0 m-0">
                  <div class="col-md-4 p-0">Container Number:</div>
                  <div class="text-left col-md-7 p-0">
                    <b> {{ gettokenDetails.container_number }}</b>
                  </div>
                </div>
                <div class="col-md-6 d-flex p-0 m-0">
                  <div class="col-md-4 p-0">Seal Number:</div>
                  <div class="text-left col-md-7 p-0">
                    <b> {{ gettokenDetails.seal_number }}</b>
                  </div>
                </div>
                <div class="col-md-6 d-flex p-0 m-0">
                  <div class="col-md-4 p-0">Driver Name:</div>
                  <div class="text-left col-md-7 p-0">
                    <b> {{ gettokenDetails.driver_name }}</b>
                  </div>
                </div>
                <div class="col-md-6 d-flex p-0 m-0">
                  <div class="col-md-4 p-0">
                    Additional name along with Driver:
                  </div>
                  <div class="text-left col-md-7 p-0">
                    <b> {{ gettokenDetails.additional_name }}</b>
                  </div>
                </div>
                <div class="col-md-6 d-flex p-0 m-0">
                  <div class="col-md-4 p-0">Driver Number:</div>
                  <div class="text-left col-md-7 p-0">
                    <b> {{ gettokenDetails.driver_number }}</b>
                  </div>
                </div>
                <div class="col-md-6 d-flex p-0 m-0">
                  <div class="col-md-4 p-0">Driver licence Number:</div>
                  <div class="text-left col-md-7 p-0">
                    <b> {{ gettokenDetails.driver_license_number }}</b>
                  </div>
                </div>
                <div class="col-md-6 d-flex p-0 m-0">
                  <div class="col-md-4 p-0">Event Status:</div>
                  <div class="text-left col-md-7 p-0">
                    <b> {{ gettokenDetails.latest_event_status }}</b>
                  </div>
                </div>
                <div class="col-md-6 d-flex p-0 m-0">
                  <div class="col-md-4 p-0">Report in time:</div>
                  <div class="text-left col-md-7 p-0">
                    <b>{{
                      gettokenDetails.reported_in_datetime
                        | localMomentNew
                        | moment("DD MMM, YYYY hh:mm A")
                    }}</b>
                  </div>
                </div>
              </v-col>
            </v-col></v-row
          >
          <v-divider></v-divider>
          <v-row class="pl-0">
            <v-col cols="12">
              <v-col cols="12" class="pl-0">
                <div><b>DOCK IN</b></div>

                <div class="col-md-6 d-flex p-0 m-0">
                  <div class="col-md-4 p-0 text-medium-emphasis">
                    Storer Name:
                  </div>
                  <div class="text-left col-md-7 p-0">
                    <b> {{ gettokenDetails.storer }}</b>
                  </div>
                </div>
                <div class="col-md-6 d-flex p-0 m-0">
                  <div class="col-md-4 p-0 text-medium-emphasis">
                    Unloading Type:
                  </div>
                  <div class="text-left col-md-7 p-0">
                    <b> {{ gettokenDetails.unloading_type }}</b>
                  </div>
                </div>
                <div class="col-md-6 d-flex p-0 m-0">
                  <div class="col-md-4 p-0 text-medium-emphasis">Comments:</div>
                  <div class="text-left col-md-7 p-0">
                    <b> {{ gettokenDetails.dock_in_remark }}</b>
                  </div>
                </div>
              </v-col>
              <v-divider></v-divider>
            </v-col>
            <v-divider></v-divider>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card-text v-if="gettokenDetails.token_number">
        <v-form ref="formOut">
          <v-row>
            <v-col
              cols="12"
              sm="6"
              md="6"
              v-if="
                gettokenDetails.storer &&
                (gettokenDetails.purpose == 'Inbound' ||
                  gettokenDetails.purpose == 'Both')
              "
            >
              <v-autocomplete
                label="Do You have ASN Number?"
                :items="wms_dropdown"
                v-model="wms_asn"
                hide-details="auto"
                @input="wms_change"
                outlined
                :rules="[(v) => !!v || 'Value is required.']"
                class="required"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="5" md="5" v-if="wms_asn == 'Yes'">
              <v-autocomplete
                label="ASN (Receipt No.)"
                :items="inboundList"
                v-model="inbound_array"
                multiple
                hide-details="auto"
                :rules="[
                  (v) => !!v || 'Value is required.',
                  (v) => v.length > 0 || 'Value is required.',
                ]"
                class="required"
                outlined
                :item-text="
                  (item) => `${item.receipt_key} - (${item.receipt_no})`
                "
                item-value="receipt_key"
                v-bind:search-input.sync="searchText"
                @change="clearSearchText"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="6" sm="6" v-if="wms_asn == 'No'">
              <v-text-field
                v-model="asn_shipment_number"
                label="ASN Number"
                class="required"
                hide-details="auto"
                :rules="[
                  (v) =>
                    (!!v && v.trim().search(/-/) === -1) ||
                    'Please enter data in valid format.',
                ]"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="1" sm="1" v-if="wms_asn == 'Yes'">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon
                    medium
                    v-on="on"
                    @click="syncOrder"
                    :loading="syncloader"
                  >
                    mdi-sync
                  </v-icon>
                </template>
                <span>Sync Order</span>
              </v-tooltip>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="6"
              v-if="
                gettokenDetails.storer &&
                (gettokenDetails.purpose == 'Outbound' ||
                  gettokenDetails.purpose == 'Both')
              "
            >
              <v-autocomplete
                label="Do You have Shipment Number?"
                :items="wms_dropdown"
                v-model="wms_shipment"
                hide-details="auto"
                @input="wms_change"
                class="required"
                outlined
                :rules="[(v) => !!v || 'Value is required.']"
              ></v-autocomplete>
            </v-col>

            <v-col
              cols="12"
              sm="5"
              md="5"
              v-if="wms_shipment == 'Yes' && gettokenDetails.storer"
            >
              <v-autocomplete
                label="Shipment (Receipt No.)"
                :items="outboundList"
                v-model="outbound_array"
                multiple
                :item-text="
                  (item) => `${item.order_key} - (${item.receipt_no})`
                "
                item-value="order_key"
                class="required"
                hide-details="auto"
                :rules="[
                  (v) => !!v || 'Value is required.',
                  (v) => v.length > 0 || 'Value is required.',
                ]"
                outlined
                v-bind:search-input.sync="searchTextShipment"
                @change="clearSearchTextShipment"
              ></v-autocomplete>
            </v-col>

            <v-col
              cols="12"
              md="6"
              sm="6"
              v-if="wms_shipment == 'No' && gettokenDetails.storer"
            >
              <v-text-field
                v-model="shipment_number"
                label="Shipment Number"
                class="required"
                hide-details="auto"
                :rules="[
                  (v) =>
                    (!!v && v.trim().search(/-/) === -1) ||
                    'Please enter data in valid format.',
                ]"
                outlined
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="1"
              sm="1"
              v-if="wms_shipment == 'Yes' && gettokenDetails.storer"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon
                    medium
                    v-on="on"
                    @click="syncOrderOutbound"
                    :loading="syncloaderOutbound"
                  >
                    mdi-sync
                  </v-icon>
                </template>
                <span>Sync Order</span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-divider class="my-5"></v-divider>

          <v-row>
            <v-col cols="12" md="6" sm="6">
              <v-text-field
                v-model="lpo_number"
                label="LPO/Reference Number"
                class="required"
                hide-details="auto"
                outlined
                :rules="[
                  (v) =>
                    (!!v && v.trim().search(/-/) === -1) ||
                    'Please enter data in valid format.',
                ]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="6">
              <v-text-field
                v-model="projected_quantity"
                label="Projected Quantity"
                class="required"
                hide-details="auto"
                type="number"
                outlined
                min="0"
                :rules="[
                  (v) =>
                    (!!v && v.trim().search(/-/) === -1) ||
                    'Please enter data in valid format.',
                ]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="6">
              <v-text-field
                v-model="received_quantity"
                label="Received/Loaded Quantity"
                class="required"
                hide-details="auto"
                type="number"
                outlined
                min="0"
                :rules="[
                  (v) =>
                    (!!v && v.trim().search(/-/) === -1) ||
                    'Please enter data in valid format.',
                ]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6" sm="6">
              <v-text-field
                v-model="pallet_quantity"
                label="Pallet Quantity"
                class="required"
                hide-details="auto"
                type="number"
                min="0"
                outlined
                :rules="[
                  (v) =>
                    (!!v && v.trim().search(/-/) === -1) ||
                    'Please enter data in valid format.',
                ]"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-divider class="my-5"></v-divider>

          <v-row>
            <v-col cols="12" md="6" sm="6">
              <v-autocomplete
                v-model="rto_employee_count"
                label="RTO Employee Count"
                class="required"
                :items="rtoEmployeeCounts"
                outlined
                hide-details="auto"
                :rules="[
                  (v) =>
                    (v !== null && v !== undefined) || 'Value is required.',
                ]"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="6" sm="6">
              <v-autocomplete
                v-model="flo_employee_count"
                label="FLO Employee count"
                class="required"
                :items="rtoEmployeeCounts"
                outlined
                hide-details="auto"
                :rules="[
                  (v) =>
                    (v !== null && v !== undefined) || 'Value is required.',
                ]"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="6" sm="6">
              <v-autocomplete
                v-model="tc_employee_count"
                label="TC Employee Count"
                class="required"
                :items="rtoEmployeeCounts"
                outlined
                hide-details="auto"
                :rules="[
                  (v) =>
                    (v !== null && v !== undefined) || 'Value is required.',
                ]"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="6" sm="6">
              <v-autocomplete
                v-model="wha_employee_count"
                label="WHA  Employee Count"
                class="required"
                :items="rtoEmployeeCounts"
                outlined
                hide-details="auto"
                :rules="[
                  (v) =>
                    (v !== null && v !== undefined) || 'Value is required.',
                ]"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" md="6" sm="6">
              <v-autocomplete
                v-model="osl_employee_count"
                label="Outsourced Employee Count"
                class="required"
                hide-details="auto"
                outlined
                :items="rtoEmployeeCounts"
                :rules="[
                  (v) =>
                    (v !== null && v !== undefined) || 'Value is required.',
                ]"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-divider class="my-5"></v-divider>
          <v-row>
            <v-col cols="12" md="12" sm="12">
              <v-textarea
                maxlength="200"
                v-model="dock_out_comment"
                label="Comments"
                class="required"
                hide-details="auto"
                outlined
                auto-grow
                rows="1"
                row-height="15"
                :rules="[(v) => !!v || 'Comment is required.']"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>

        <v-col
          class="pl-0"
          v-if="
            gettokenDetails.latest_event_status == 'WAREHOUSE_DOCK_IN' &&
            gettokenDetails.active !== 3
          "
        >
          <v-btn color="primary" :loading="loader" @click="gateIn" class="mt-2"
            >Dock OUT</v-btn
          ></v-col
        >
        <v-col v-else style="color: red">
          <b v-if="showMessage"
            >Unable to Dock OUT because token status is
            {{ gettokenDetails.latest_event_status }}</b
          >
        </v-col>
      </v-card-text>
    </v-card>
  </v-col>
</template>
<script>
import { axios } from "@/plugins/http-request.js";
import { mapActions } from "vuex";

export default {
  data: () => ({
    searchText: "",

    syncloader: false,
    loader: false,
    gettokenDetails: {},
    tokenNumber: "",
    lpo_number: "",
    asn_shipment_number: "",
    projected_quantity: "",
    received_quantity: "",
    dock_out_comment: "",
    rto_employee_count: "",
    flo_employee_count: "",
    tc_employee_count: "",
    wha_employee_count: "",
    pallet_quantity: "",
    osl_employee_count: "",
    showMessage: true,
    rtoEmployeeCounts: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    wms_dropdown: ["Yes", "No"],
    wms_asn: "",
    wms_shipment: "",
    inboundList: [],
    outboundList: [],
    inbound_array: [],
    outbound_array: [],
    shipment_number: "",
    syncloaderOutbound: false,
    searchTextShipment: "",
  }),

  methods: {
    ...mapActions(["snackBar", "inboundSync", "outboundSync"]),
    syncOrder() {
      this.syncloader = true;
      let payload = {
        warehouse: this.gettokenDetails.warehouse_id__name,
      };
      this.inboundSync(payload)
        .then((response) => {
          this.snackBar({
            color: "success",
            message: response.data.message,
          });
          this.syncloader = false;
          this.wms_change();
        })
        .catch(() => {
          this.syncloader = false;
        });
    },
    clearSearchText() {
      this.searchText = ""; // Clears the search input after selection
    },
    clearSearchTextShipment() {
      this.searchTextShipment = "";
    },

    syncOrderOutbound() {
      this.syncloaderOutbound = true;
      let payload = {
        warehouse: this.gettokenDetails.warehouse_id__name,
      };
      this.outboundSync(payload)
        .then((response) => {
          this.snackBar({
            color: "success",
            message: response.data.message,
          });
          this.syncloaderOutbound = false;
          this.wms_change();
        })
        .catch(() => {
          this.syncloaderOutbound = false;
        });
    },
    callFunction() {
      this.loader = true;

      axios
        .get(`/api/pas/search_token?token_number=${this.tokenNumber}`)
        .then((res) => {
          this.loader = false;
          if (res.data.data.records.length == 0) {
            this.loader = false;
            this.snackBar({
              color: "error",
              message: "No Record Found",
            });
          } else {
            this.gettokenDetails = res.data.data.records[0];
          }
        });
    },
    save() {
      this.lpo_number = "";
      this.asn_shipment_number = "";
      this.projected_quantity = "";
      this.received_quantity = "";
      this.dock_out_comment = "";
      this.rto_employee_count = "";
      this.flo_employee_count = "";
      this.tc_employee_count = "";
      this.wha_employee_count = "";
      this.pallet_quantity = "";
      this.osl_employee_count = "";
      this.inbound_array = [];
      this.outbound_array = [];
      this.shipment_number = "";
      this.gettokenDetails = {};
      this.wms_asn = "";
      this.wms_shipment = "";
      if (!this.$refs.form.validate()) {
        return;
      }
      this.callFunction();
    },
    wms_change() {
      if (this.wms_asn == "Yes") {
        this.asn_shipment_number = "";
      }
      if (this.wms_shipment == "Yes") {
        this.shipment_number = "";
      }
      if (this.wms_asn == "Yes" || this.wms_shipment == "Yes") {
        let type = "";
        if (this.gettokenDetails.purpose == "Inbound") {
          type = 1;
        } else if (this.gettokenDetails.purpose == "Outbound") {
          type = 2;
        } else if (this.gettokenDetails.purpose == "Both") {
          type = 3;
        }
        axios
          .get(
            `/api/pas-inbound-outbound-list?type=${type}&storer_key=${this.gettokenDetails.storer}&warehouse_id=${this.gettokenDetails.warehouse_id}&token_number=${this.gettokenDetails.token_number}`
          )
          .then((res) => {
            this.inboundList = res.data.data.receipt_key;

            this.outboundList = res.data.data.order_keys;
          });
      } else if (this.wms_asn == "No") {
        this.inbound_array = [];
      } else if (this.wms_shipment == "No") {
        this.outbound_array = [];
      }
    },
    gateIn() {
      if (!this.$refs.formOut.validate()) {
        return;
      }
      let data = {
        event: "WAREHOUSE_DOCK_OUT",
        dock_out_comment: this.dock_out_comment,
        lpo_number: this.lpo_number,
        asn_shipment_number: this.asn_shipment_number,
        projected_quantity: this.projected_quantity,
        received_quantity: this.received_quantity,
        rto_employee_count: this.rto_employee_count,
        flo_employee_count: this.flo_employee_count,
        tc_employee_count: this.tc_employee_count,
        wha_employee_count: this.wha_employee_count,
        pallet_quantity: this.pallet_quantity,
        osl_employee_count: this.osl_employee_count,
        is_inbound_wms: this.wms_asn,
        is_outbound_wms: this.wms_shipment,
        shipment_number: this.shipment_number,
        inbound_receipt_keys: this.inbound_array.join(","),
        outbound_order_key: this.outbound_array.join(","),
      };
      if (data.is_inbound_wms == "No") {
        delete data.inbound_receipt_keys;
      } else {
        delete data.asn_shipment_number;
      }
      if (data.is_outbound_wms == "No") {
        delete data.outbound_order_key;
      } else {
        delete data.shipment_number;
      }
      axios
        .post(`/api/warehouse/dock_in_out/${this.gettokenDetails.id}`, data)
        .then((res) => {
          this.snackBar({
            color: "success",
            message: res.data.data.message,
          });
          this.callFunction();
          this.showMessage = false;
        });
    },
  },
};
</script>
<style scoped>
.p-0 {
  padding: 0px !important;
}
</style>
